module.exports = __webpack_public_path__ + "img/crossInCircle.b4909484.svg";